<!-- <div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="row error-msg">
    <div class="col-12">
      <div class="fa fa-shield fa-5x"></div>

      <p class="message-title">{{'General.access.denied.title' | translate}}</p>
      <p class="message-summary">{{'General.access.denied.message' | translate}}</p>
    </div>
  </div>
</div> -->
<error-message iconClass="fa fa-shield fa-5x" tittleKey="General.access.denied.title"
  messageKey="General.access.denied.message"></error-message>